import { Insurant, InsurantDto, insurantFromDto } from '@models/insurant';
import { PoolObject } from '@core';
import { CustomerDto } from '@models/customer';
import { dtoToInsuranceType, InsuranceType, InsuranceTypeDto } from './insurance-type';

export interface Contract {
    id: number;
    customer: CustomerDto;
    insuranceType: InsuranceType;
    insuranceNumber: string;
    signatureDate: string;
    renewalDate: string;
    contractFrom: string;
    contractTo: string;
    insurants: Insurant[];
    insuranceObject: string;
    objectValue: number;
    objectPool: PoolObject[];
    hasOpenDamages: boolean;
}

export interface ContractDto {
    Id: number;
    Customer: CustomerDto;
    InsuranceType: InsuranceTypeDto;
    InsuranceNumber: string;
    SignatureDate: string;
    RenewalDate: string;
    ContractFrom: string;
    ContractTo: string;
    Insurants: InsurantDto[];
    InsuranceObject: string;
    ObjectValue: number;
    ObjectPool: PoolObject[];
    HasOpenDamages: boolean;
}

export function contractFromDto(dto: ContractDto): Contract {
    return {
        id: dto.Id,
        customer: dto.Customer,
        insuranceType: dtoToInsuranceType(dto.InsuranceType),
        insuranceNumber: dto.InsuranceNumber,
        signatureDate: dto.SignatureDate,
        renewalDate: dto.RenewalDate,
        contractFrom: dto.ContractFrom,
        contractTo: dto.ContractTo,
        insurants: dto.Insurants.map((insurantDto: InsurantDto) => insurantFromDto(insurantDto)),
        insuranceObject: dto.InsuranceObject,
        objectValue: dto.ObjectValue,
        objectPool: dto.ObjectPool,
        hasOpenDamages: dto.HasOpenDamages,
    };
}
